import { Action } from 'redux';
import { TextSettingsActionListEnum } from './actionsTypes';
import { TextSettingsTypes } from '../textSettingsTypes';

interface TextSettingsChangeFontTypeActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_FONT_TYPE;
  fontType: string;
}

interface TextSettingsChangeFontSizeActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_FONT_SIZE;
  fontSize: number;
}

interface TextSettingsChangeLineHeightActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_LINE_HEIGHT;
  lineHeight: number;
}

interface TextSettingsChangeIndentRightActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_INDENT_RIGHT;
  indentRight: number;
}

interface TextSettingsChangeIndentLeftActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_INDENT_LEFT;
  indentLeft: number;
}

interface TextSettingsChangeIndentTopActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_INDENT_TOP;
  indentTop: number;
}

interface TextSettingsChangeTextColorActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_TEXT_COLOR;
  textColor: string;
}

interface TextSettingsChangeIndentRedLineActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_INDENT_RED_LINE;
  indentRedLine: number;
}

interface TextSettingsChangeIndentLetterActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_INDENT_LETTER;
  indentLetter: number;
}

interface TextSettingsChangeIndentWordActionType extends Action {
  type: TextSettingsActionListEnum.CHANGE_INDENT_WORD;
  indentWord: number;
}

interface TextSettingsToggleRandomFontSizeActionType extends Action {
  type: TextSettingsActionListEnum.TOGGLE_RANDOM_FONT_SIZE;
  isRandomFontSize: boolean;
}

interface TextSettingsToggleRandomRotateLetterActionType extends Action {
  type: TextSettingsActionListEnum.TOGGLE_RANDOM_ROTATE_LETTER;
  isRandomRotateLetter: boolean;
}

interface TextSettingsToggleRandomLineLeftIndentActionType extends Action {
  type: TextSettingsActionListEnum.TOGGLE_RANDOM_LINE_LEFT_INDENT;
  isRandomLineLeftIndent: boolean;
}

interface ResetTextSettingsActionType extends Action {
  type: TextSettingsActionListEnum.RESET_TEXT_SETTINGS;
  textSettings: TextSettingsTypes;
}

export type TextSettingsActionType = TextSettingsChangeFontTypeActionType
| TextSettingsChangeFontSizeActionType
| TextSettingsChangeLineHeightActionType
| TextSettingsChangeIndentRightActionType
| TextSettingsChangeIndentLeftActionType
| TextSettingsChangeIndentTopActionType
| TextSettingsChangeTextColorActionType
| TextSettingsChangeIndentRedLineActionType
| TextSettingsChangeIndentLetterActionType
| TextSettingsChangeIndentWordActionType
| TextSettingsToggleRandomFontSizeActionType
| TextSettingsToggleRandomRotateLetterActionType
| TextSettingsToggleRandomLineLeftIndentActionType
| ResetTextSettingsActionType;

export const textSettingsChangeFontTypeAction = (fontType: string): TextSettingsChangeFontTypeActionType => ({
  type: TextSettingsActionListEnum.CHANGE_FONT_TYPE,
  fontType,
});

export const textSettingsChangeFontSizeAction = (fontSize: number): TextSettingsChangeFontSizeActionType => ({
  type: TextSettingsActionListEnum.CHANGE_FONT_SIZE,
  fontSize,
});

export const textSettingsChangeLineHeightAction = (lineHeight: number): TextSettingsChangeLineHeightActionType => ({
  type: TextSettingsActionListEnum.CHANGE_LINE_HEIGHT,
  lineHeight,
});

export const textSettingsChangeIndentRightAction = (indentRight: number): TextSettingsChangeIndentRightActionType => ({
  type: TextSettingsActionListEnum.CHANGE_INDENT_RIGHT,
  indentRight,
});

export const textSettingsChangeIndentLeftAction = (indentLeft: number): TextSettingsChangeIndentLeftActionType => ({
  type: TextSettingsActionListEnum.CHANGE_INDENT_LEFT,
  indentLeft,
});

export const textSettingsChangeIndentTopAction = (indentTop: number): TextSettingsChangeIndentTopActionType => ({
  type: TextSettingsActionListEnum.CHANGE_INDENT_TOP,
  indentTop,
});

export const textSettingsChangeTextColorAction = (textColor: string): TextSettingsChangeTextColorActionType => ({
  type: TextSettingsActionListEnum.CHANGE_TEXT_COLOR,
  textColor,
});

export const textSettingsChangeIndentRedLineAction = (indentRedLine: number): TextSettingsChangeIndentRedLineActionType => ({
  type: TextSettingsActionListEnum.CHANGE_INDENT_RED_LINE,
  indentRedLine,
});

export const textSettingsChangeIndentLetterAction = (indentLetter: number): TextSettingsChangeIndentLetterActionType => ({
  type: TextSettingsActionListEnum.CHANGE_INDENT_LETTER,
  indentLetter,
});

export const textSettingsChangeIndentWordAction = (indentWord: number): TextSettingsChangeIndentWordActionType => ({
  type: TextSettingsActionListEnum.CHANGE_INDENT_WORD,
  indentWord,
});

export const textSettingsToggleRandomFontSizeAction = (isRandomFontSize: boolean): TextSettingsToggleRandomFontSizeActionType => ({
  type: TextSettingsActionListEnum.TOGGLE_RANDOM_FONT_SIZE,
  isRandomFontSize,
});

export const textSettingsToggleRandomRotateLetterAction = (isRandomRotateLetter: boolean): TextSettingsToggleRandomRotateLetterActionType => ({
  type: TextSettingsActionListEnum.TOGGLE_RANDOM_ROTATE_LETTER,
  isRandomRotateLetter,
});

export const textSettingsToggleRandomLineLeftIndentAction = (isRandomLineLeftIndent: boolean): TextSettingsToggleRandomLineLeftIndentActionType => ({
  type: TextSettingsActionListEnum.TOGGLE_RANDOM_LINE_LEFT_INDENT,
  isRandomLineLeftIndent,
});

export const resetTextSettingsAction = (textSettings: TextSettingsTypes): ResetTextSettingsActionType => ({
  type: TextSettingsActionListEnum.RESET_TEXT_SETTINGS,
  textSettings,
});
